var map = {
	"./404-01.png": 2979,
	"./appointment-01.png": 2980,
	"./appointment-02.png": 2981,
	"./arrow-up-40.png": 2982,
	"./checkin/user.png": 2983,
	"./checkin/weekly_icon.png": 2984,
	"./checkin/workplace-checkin - Copy.png": 2985,
	"./checkin/workplace-checkin.png": 2986,
	"./checkin/workplace.png": 2987,
	"./employee/no_image.png": 41,
	"./fav_16-01.png": 2988,
	"./fav_180-01.png": 2989,
	"./fav_192-01.png": 2990,
	"./fav_32-01.png": 2991,
	"./fav_48-01.png": 2992,
	"./filter-btn.png": 579,
	"./filter-btn2.png": 2993,
	"./flag_en.png": 580,
	"./flag_en_focus.png": 581,
	"./flag_en_icon.png": 221,
	"./flag_th.png": 582,
	"./flag_th_focus.png": 583,
	"./flag_th_icon.png": 222,
	"./icon_appointment.png": 584,
	"./icon_appointment_dark.png": 585,
	"./icon_hr.png": 2994,
	"./icon_leave.png": 586,
	"./icon_leave_dark.png": 587,
	"./icon_todolist.png": 588,
	"./icon_todolist_dark.png": 589,
	"./icon_training.png": 590,
	"./icon_training_dark.png": 591,
	"./leave-01.png": 2995,
	"./leave-02.png": 2996,
	"./logo.png": 2997,
	"./no-image-landscape.png": 592,
	"./orgchart/orgchart-heading.png": 2998,
	"./penguin.png": 2999,
	"./sort_asc.png": 3000,
	"./sort_both.png": 3001,
	"./sort_desc.png": 3002,
	"./todolist-01.png": 3003,
	"./todolist-02.png": 3004,
	"./training-01.png": 3005,
	"./training-02.png": 3006
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4035;



//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/.*\.png$
// module id = 4035
// module chunks = 1